import { useEffect, useState, useCallback } from "react";
import { api, dateShort } from "../lib/api";
import { PageHeader, EmptyState } from "../components/Bits";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "../components/ui/dialog";
import { Textarea } from "../components/ui/textarea";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { Plus, Trash2, Pencil, Users } from "lucide-react";
import { toast } from "sonner";

const empty = { name: "", phone: "", email: "", address: "", notes: "" };

export default function Customers() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);
  const load = useCallback(() => api.get("/customers").then((r) => setList(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const openNew = () => { setForm(empty); setEditId(null); setOpen(true); };
  const openEdit = (c) => { setForm(c); setEditId(c.id); setOpen(true); };
  const submit = async () => {
    if (!form.name) return toast.error("İsim zorunlu");
    if (editId) await api.put(`/customers/${editId}`, form); else await api.post("/customers", form);
    toast.success("Kaydedildi"); setOpen(false); load();
  };
  const del = async (c) => { if (!window.confirm("Silinsin mi?")) return; await api.delete(`/customers/${c.id}`); load(); };

  return (
    <div className="p-8">
      <PageHeader eyebrow="CRM" title="Müşteriler" subtitle="Müşteri veritabanınızı yönetin"
        actions={<Button data-testid="customer-new-btn" onClick={openNew} className="bg-blue-600 hover:bg-blue-700"><Plus className="h-4 w-4 mr-2" />Yeni Müşteri</Button>} />
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>{editId ? "Müşteri Düzenle" : "Yeni Müşteri"}</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>İsim</Label><Input data-testid="customer-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label>Telefon</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
              <div><Label>E-posta</Label><Input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
            </div>
            <div><Label>Adres</Label><Textarea value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></div>
            <div><Label>Notlar</Label><Textarea value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} /></div>
          </div>
          <DialogFooter><Button data-testid="customer-save-btn" onClick={submit} className="bg-blue-600 hover:bg-blue-700">Kaydet</Button></DialogFooter>
        </DialogContent>
      </Dialog>

      {list.length === 0 ? (
        <EmptyState icon={Users} title="Henüz müşteri yok" description="İlk müşterinizi ekleyerek başlayın." />
      ) : (
        <Card className="border-slate-200 overflow-hidden">
          <Table>
            <TableHeader><TableRow className="bg-slate-50">
              <TableHead className="text-xs uppercase tracking-widest">İsim</TableHead>
              <TableHead className="text-xs uppercase tracking-widest">Telefon</TableHead>
              <TableHead className="text-xs uppercase tracking-widest">E-posta</TableHead>
              <TableHead className="text-xs uppercase tracking-widest">Eklendi</TableHead>
              <TableHead className="text-right"></TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {list.map((c) => (
                <TableRow key={c.id} className="hover:bg-slate-50">
                  <TableCell className="font-medium">{c.name}</TableCell>
                  <TableCell className="text-slate-600">{c.phone || "-"}</TableCell>
                  <TableCell className="text-slate-600">{c.email || "-"}</TableCell>
                  <TableCell className="text-sm text-slate-500">{dateShort(c.created_at)}</TableCell>
                  <TableCell className="text-right">
                    <Button size="icon" variant="ghost" onClick={() => openEdit(c)}><Pencil className="h-4 w-4" /></Button>
                    <Button size="icon" variant="ghost" onClick={() => del(c)}><Trash2 className="h-4 w-4 text-red-500" /></Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      )}
    </div>
  );
}
